import { noop } from "@common/helpers/function";
import { BillStatus as BillStatusEnum } from "@common/types/bill";
import { BillStatus } from "../../../../bills/BillStatus";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps, defaultBillStatuses } from "../../lib";

export const BillStatusFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const options: FilterMultiselectOption[] = Object.values(
        BillStatusEnum,
    ).map((status) => ({
        value: status,
        label: <BillStatus status={status} showText />,
        searchableLabel: status,
    }));

    const statuses =
        filters.billStatuses && filters.billStatuses.length > 0
            ? filters.billStatuses
            : defaultBillStatuses;

    return (
        <FilterMultiselect
            inDropdown={false}
            searchable={false}
            options={options}
            value={statuses}
            onChange={(val) => {
                onChange({ billStatuses: val as BillStatusEnum[] });
            }}
            name="billStatuses"
            onBlur={noop}
        />
    );
};
